import { render } from "./Splash.vue.js?vue&type=template&id=4f806dad&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Splash.vue?vue&type=template&id=4f806dad&scoped=true"
import script from "./Splash.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Splash.vue?vue&type=script&lang=js"
export * from "./Splash.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Splash.vue?vue&type=script&lang=js"

import "./Splash.vue.scss?vue&type=style&index=0&id=4f806dad&lang=scss&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Splash.vue?vue&type=style&index=0&id=4f806dad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f806dad"],['__file',"src/Web/scripts/pages/Splash.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f806dad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f806dad', __exports__)) {
    api.reload('4f806dad', __exports__)
  }
  
  module.hot.accept("./Splash.vue.js?vue&type=template&id=4f806dad&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Splash.vue?vue&type=template&id=4f806dad&scoped=true", () => {
    api.rerender('4f806dad', render)
  })

}


export default __exports__